/* Built In Imports */

/* External Imports */
import { Box, Grid, GridItem, Text } from '@chakra-ui/react';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import { render } from 'datocms-structured-text-to-html-string';
import { usePathname } from 'next/navigation';

/* Services */
/* Config */
import ProgressiveBg from '@components/UI/ProgressiveBg';

/**
 * @param {Object} sectionContent - Data
 * @param {string} lang - Language of the page
 * @returns
 */

const WhoCanDoV5WOB = ({ sectionContent, lang }) => {
  const path = usePathname();
  const under25Url = path.includes('under-25s');

  return (
    <Box
      bg={
        under25Url
          ? 'url(https://static.sadhguru.org/d/46272/1710743888-1710584276-pbg1.jpg) repeat'
          : '#F1EBDF'
      }
      maxW={'100%'}
      pt={{ base: '55px', md: '80px', lg: '120px' }}
      pb={{ base: '69px', md: '80px', lg: '110px'  }}
      px={{ base: 4, md: 8 }}
    >
      <Box maxW={'1031px'} mx={'auto'}>
        <Text
          color={'#3B444B'}
          fontFamily={'FedraSansStd-medium'}
          fontSize={{ base: '32px', md: '64px' }}
          lineHeight={{ base: '35.2px', md: '64px' }}
          fontWeight={'500'}
          textAlign={{ base: 'start' }}
          pb={{ base: '28px', md: '50px' }}
        >
          {sectionContent[0].text}
        </Text>
        <Grid
          gap={{ base: '20px' }}
          templateColumns={{ base: '1fr', md: '1fr 1fr' }}
        >
          <GridItem colSpan={{ base: 1, md: 1 }}>
            <ProgressiveBg
              backgroundImage={{
                base:
                  sectionContent[2]?.mobileImage?.url ??
                  sectionContent[2]?.image?.url,
                sm: sectionContent[2]?.image?.url,
                md: sectionContent[2]?.image?.url,
                lg: sectionContent[2]?.image?.url,
                xl: sectionContent[2]?.image?.url,
                '2xl': sectionContent[2]?.image?.url,
              }}
              width={{ base: '100%', md: '100%' }}
              height={{ base: '200px', md: '470px' }}
              display="flex"
              alignItems="flex-end"
              bgSize="cover"
              bgPos="top center"
              p={{ base: '20px', md: '44px 40px' }}
              mx={{ base: '0', md: 'auto' }}
              position={'relative'}
              lazyLoad
            >
              <Box
                position="absolute"
                bottom="0"
                left="0"
                right="0"
                height={{ base: '119px', md: '270px' }}
                bg="linear-gradient(180deg, rgba(0, 1, 67, 0) 0%, #000143 77.9%)"
                zIndex="1"
              />
              <Text
                color={'#FF9840'}
                fontFamily={'FedraSansStd-medium'}
                fontSize={{ base: '14px', md: '24px' }}
                lineHeight={{ base: '18px', md: '33.6px' }}
                fontWeight={'500'}
                zIndex={1}
              >
                {sectionContent?.[3]?.text}
              </Text>
            </ProgressiveBg>
          </GridItem>
          <GridItem colSpan={{ base: 1, md: 1 }}>
            <ProgressiveBg
              backgroundImage={{
                base:
                  sectionContent[4]?.mobileImage?.url ??
                  sectionContent[4]?.image?.url,
                sm: sectionContent[4]?.image?.url,
                md: sectionContent[4]?.image?.url,
                lg: sectionContent[4]?.image?.url,
                xl: sectionContent[4]?.image?.url,
                '2xl': sectionContent[4]?.image?.url,
              }}
              width={{ base: '100%', md: '100%' }}
              height={{ base: '200px', md: '470px' }}
              display="flex"
              alignItems="flex-end"
              bgSize="cover"
              bgPos="top center"
              p={{ base: '20px', md: '27px 40px' }}
              mx={{ base: '0', md: 'auto' }}
              position={'relative'}
              lazyLoad
            >
              <Box
                position="absolute"
                bottom="0"
                left="0"
                right="0"
                height={{ base: '119px', md: '270px' }}
                bg="linear-gradient(180deg, rgba(0, 1, 67, 0) 0%, #000143 77.9%)"
                zIndex="1"
              />
              <Text
                color={'#FF9840'}
                fontFamily={'FedraSansStd-medium'}
                fontSize={{ base: '14px', md: '24px' }}
                lineHeight={{ base: '18px', md: '33.6px' }}
                fontWeight={'500'}
                zIndex={1}
              >
                {sectionContent?.[5]?.text}
              </Text>
            </ProgressiveBg>
          </GridItem>
        </Grid>
      </Box>
      <Box
        maxW={'830px'}
        mx={'auto'}
        textAlign={'center'}
        mt={{ base: '28px', md: '60px' }}
        mb={{ base: '0', md: '25px' }}
      >
        <StructuredTextParser
          str={render(sectionContent[6]?.body)}
          color="#000"
          textAlign={{
            base: 'left',
            md: 'center',
          }}
          fontSize={{ base: '18px', md: '22px' }}
          fontWeight="400"
          mx="auto"
          className={`contentText`}
          px="0px"
          fontFamily={'FedraSansStd-book'}
          fontStyle={'italic'}
        />
      </Box>
      <style global jsx>
        {`
          .contentText p:first-child {
            padding-bottom: 28px;
          }
            .contentText  a {
        color: '#F37021',
        textDecoration: 'underline',
      },
        `}
      </style>
    </Box>
  );
};

export default WhoCanDoV5WOB;
